function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import React from 'react';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { Popover } from '../../../components/popover';
import { FilterPanel } from './FilterPanel';
import { DownOne, Filter, UpOne } from './../../../common/icons';
export function TableCellHead(props) {
  var _usePrefixCls;

  var className = props.className,
      title = props.title,
      _props$align = props.align,
      align = _props$align === void 0 ? 'left' : _props$align,
      _props$valign = props.valign,
      valign = _props$valign === void 0 ? 'middle' : _props$valign,
      _props$ellipsis = props.ellipsis,
      ellipsis = _props$ellipsis === void 0 ? false : _props$ellipsis,
      onOrderClick = props.onOrderClick,
      _props$order = props.order,
      order = _props$order === void 0 ? 'reset' : _props$order,
      _props$sortable = props.sortable,
      sortable = _props$sortable === void 0 ? false : _props$sortable,
      _props$filterable = props.filterable,
      filterable = _props$filterable === void 0 ? false : _props$filterable,
      filterValue = props.filterValue,
      filterMultiple = props.filterMultiple,
      filterDataSource = props.filterDataSource,
      onFilterChange = props.onFilterChange,
      extra = _objectWithoutProperties(props, ["className", "title", "align", "valign", "ellipsis", "onOrderClick", "order", "sortable", "filterable", "filterValue", "filterMultiple", "filterDataSource", "onFilterChange"]);

  var rtl = useDirection() === 'rtl';

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      filterState = _useToggle2[0],
      showFilter = _useToggle2[1],
      hideFilter = _useToggle2[2];

  var onOrderClickCallback = useRefCallback(onOrderClick);
  var onFilterChangeCallback = useRefCallback(onFilterChange);

  var filterChangeHandle = function filterChangeHandle(value) {
    onFilterChangeCallback(value);
    hideFilter();
  };

  var filterActive = Array.isArray(filterValue) ? filterValue.length > 0 : filterValue != null;
  var cls = classnames(usePrefixCls('table-th', (_usePrefixCls = {}, _defineProperty(_usePrefixCls, align, true), _defineProperty(_usePrefixCls, valign, true), _defineProperty(_usePrefixCls, "filterable", filterable), _defineProperty(_usePrefixCls, "ellipsis", ellipsis), _usePrefixCls)), className);
  var titleCls = classnames(usePrefixCls('table-th-title'), [align]);
  var filterCls = usePrefixCls('table-th-filter', {
    active: filterActive
  });
  var sorterCls = usePrefixCls('table-sorter', _defineProperty({}, order, true));
  var popoverCls = usePrefixCls('filter-popover');
  var filter = filterable ? React.createElement(Popover.Singleton, {
    show: filterState,
    placement: "bottom",
    lazyInit: true,
    hideToDestroy: true,
    preventOverflow: true,
    getPopper: React.createElement(FilterPanel, {
      title: title,
      multiple: filterMultiple,
      onValueChange: filterChangeHandle,
      datasource: filterDataSource,
      value: filterValue
    }),
    arrow: false,
    onShow: showFilter,
    onHide: hideFilter,
    popoverClassName: popoverCls
  }, React.createElement(Popover.ClickTrigger, {
    style: {
      height: '100%'
    }
  }, React.createElement("span", {
    className: filterCls
  }, React.createElement(Filter, {
    theme: "filled"
  })))) : null;
  var sorter = sortable ? React.createElement("span", {
    className: sorterCls,
    onClick: onOrderClickCallback
  }, React.createElement(UpOne, {
    theme: "filled"
  }), React.createElement(DownOne, {
    theme: "filled"
  })) : null;
  return React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), rtl && React.createElement("div", {
    className: titleCls
  }, sorter, filter, title) || React.createElement("div", {
    className: titleCls
  }, title, filter, sorter));
}